import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {OG_PATH} from "@/content";

const serviceId = 2
const slug = 'smart-home-system-installations-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: "Smart Home System Installations",
        description: "Integrating smart technologies like lighting, climate control, and security systems for enhanced convenience and energy efficiency.",
        keywords: "smart home installations Sydney, smart lighting systems, smart climate control, home security systems, licensed electricians Sydney, smart home integration, professional electricians Sydney",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Smart Home System Installations',
    description: 'Integrating smart technologies like lighting, climate control, and security systems for enhanced convenience and energy efficiency.',
    points: [
    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
